import React from 'react';
import { isInvoiceItemZero } from '../constants/invoiceConstants';
import { INVOICE_ITEMS_FUNCTION_LIST } from '../constants/invoiceConstants';
import PropTypes from 'prop-types';

const SingleTimeCheckboxes = ({
    inputData,
    handleCheckboxChange,
    lineData,
    isCheckboxDisabled,
    itemsList,
    invoiceIndex,
    rowIndex,
    showBorder = false
}) => {
  return (
    itemsList.map((label, index) => {
        const isZero = isInvoiceItemZero(inputData, INVOICE_ITEMS_FUNCTION_LIST[label.id]);
        const disabled = isZero === true || isCheckboxDisabled(label.id, invoiceIndex, rowIndex);
        const tdStyle = {
            backgroundColor: "#f0f0f0",
            ...(showBorder === true && rowIndex === 0 ? { borderTop: "1px solid #212529" } : {}),
        };

        return (
            <td key={index} style={tdStyle}>
                <div style={{ display: "inline-flex" }}>
                    <input
                        type="checkbox"
                        onChange={(e) =>
                        handleCheckboxChange(
                            invoiceIndex,
                            rowIndex,
                            label.id,
                            label.name,
                            e.target.checked
                        )
                        }
                        checked={
                        !!lineData[invoiceIndex]?.[rowIndex]?.selected?.includes(label.id)
                        }
                        style={{ width: "13px", height: "13px"}}
                        title={isZero === true ? 'Amount should be greater than 0' : ''}
                        disabled={disabled}
                    />
                    <span style={{ lineHeight: "14px" }} title={isZero === true ? 'Amount should be greater than 0' : ''}>
                        &nbsp;{label.name}
                    </span>
                </div>
            </td>
        );
    })
  );
};

SingleTimeCheckboxes.propTypes = {
    inputData: PropTypes.object.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
    lineData: PropTypes.object.isRequired,
    isCheckboxDisabled: PropTypes.func.isRequired,
    itemsList: PropTypes.array.isRequired,
    invoiceIndex: PropTypes.number.isRequired,
    rowIndex: PropTypes.number.isRequired,
    showBorder: PropTypes.bool
};

export default SingleTimeCheckboxes;